var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14.564,
    viewBox: "0 0 15 14.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Phone",
    d: "M15.835,11.866a.7.7,0,0,1-.223.617L13.5,14.52a1.177,1.177,0,0,1-.373.262,1.584,1.584,0,0,1-.452.139l-.1.008c-.053.005-.121.007-.206.007a7.18,7.18,0,0,1-2.628-.594,13.9,13.9,0,0,1-2.215-1.18A16.317,16.317,0,0,1,4.894,11,17.167,17.167,0,0,1,3.052,8.966a14.356,14.356,0,0,1-1.175-1.8,9.469,9.469,0,0,1-.667-1.5,7.7,7.7,0,0,1-.3-1.158,3.754,3.754,0,0,1-.064-.763c.011-.185.016-.288.016-.309A1.477,1.477,0,0,1,1,3a1.147,1.147,0,0,1,.27-.362L3.385.588A.709.709,0,0,1,3.893.372a.6.6,0,0,1,.365.116,1.079,1.079,0,0,1,.27.285L6.228,3.9a.736.736,0,0,1,.079.54.948.948,0,0,1-.27.494l-.778.756a.255.255,0,0,0-.056.1.368.368,0,0,0-.024.116,2.755,2.755,0,0,0,.286.74,6.745,6.745,0,0,0,.588.9A9.984,9.984,0,0,0,7.18,8.78a10.529,10.529,0,0,0,1.271,1.1,7.277,7.277,0,0,0,.929.578,2.5,2.5,0,0,0,.571.224l.2.038a.366.366,0,0,0,.1-.023.251.251,0,0,0,.1-.054l.9-.9a.992.992,0,0,1,.667-.246.849.849,0,0,1,.429.092h.016l3.064,1.759A.78.78,0,0,1,15.835,11.866Z",
    transform: "translate(-0.842 -0.372)",
    fill: "#ffc80a",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f2e93c07b545c4ec99d523be583840c4.svg";
export { ForwardRef as ReactComponent };